<template>
  <div>
    <div class="flex flex-wrap">
      <a-upload
        ref="upload"
        class="myupload"
        :class="limit === fileList.length?'no-file':''"
        drag
        action="#"
        @change="handleCrop"
        :before-upload="beforeAvatarUpload"
        :disabled="disabled"
        :file-list="fileList"
        :customRequest="uploadImg"
        :accept="accept"
        :remove="handleRemove"
        v-bind="$attrs"
        list-type="picture-card"
        :showUploadList="false"
      >
        <div class="myupload-div" v-if="fileList.length < limit">
          <i class="el-icon-upload" style="font-size: 20px;"></i>
          <span v-if="uploadText" class="upload-text">{{ $t(uploadText) }}</span>
        </div>
        <div v-if="isTip" slot="tip" style="margin-top: 5px; font-size: 12px;color: ;">
          <slot name="tip">
            {{ $t('图片只能上传jpg/jpeg/png文件') }}({{ cropperOption.autoCropWidth + '*' + cropperOption.autoCropHeight }}){{ $t(',其他文件请直接上传') }}
          </slot>
        </div>

      </a-upload>
      <template v-if="fileList.length">
        <div class="file-list" v-for="item in fileList" :key="item.uid">
          <!-- {{ item }} -->
          <template v-if="item.percent != 100">
            <a-progress :percent="item.percent" :strokeWidth="4" size="small" status="active" />
          </template>
          <template v-else>
            <template v-if="!imgPicSuffix.includes(item.name.substring(item.name.lastIndexOf('.')).toLowerCase())">

              {{ item.url }}
            </template>
            <template v-else>
              <img style="width: 100%;height: 100%;" :src="item.url" alt="">
            </template>
            <div class="info flex justify-center align-center">
              <a-icon title="预览文件" type="eye" style="color: white" @click="handlePreview(item)" />
              <a-icon title="删除文件" type="delete" style="color: white;margin-left: 15px;" @click="handleRemove(item)" />
            </div>
          </template>

        </div>
      </template>
    </div>

    <cropperImage
      :dialogVisible="showCropper"
      :cropper-option="cropperOption"
      :file-size="fileSize"
      :cropper-style="cropperStyle"
      @close="showCropper = false"
      @uploadCropper="uploadImg"
    ></cropperImage>
  </div>
</template>
<script>
import cropperImage from '@/components/cropperImage/index.vue'
import axios from 'axios'
export default {
  name: 'Upload',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
    bucket: {
      type: String,
      default: 'cdb-1305117004'
    },
    region: {
      type: String,
      default: 'ap-hongkong'
    },
    accept: {
      type: String,
      default: '.jpg,.png,.jpeg'
    },
    uploadText: {
      type: String,
      default: '上传文件'
    },
    isTip: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: '/common/local/file/upload'
    }
  },
  components: {
    cropperImage
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      imgPicSuffix: ['.jpg', '.jpeg', '.gif', '.png'],
      fileList: [],
      fileSrcList: [],
      showCropper: false, // 显示裁剪弹窗
      cropperOption: {
        // 裁剪配置
        img: '',
        autoCropWidth: 200,
        autoCropHeight: 200,
        filename: ''
      },
      cropperStyle: {
        // 裁剪框大小
        width: '200px',
        height: '200px'
      },
      fileSize: 1, // 文件限制个数
      cropperData: {},
      filename: ''
    }
  },
  created () {
  },
  methods: {
    init (imgs, width = 100, height = 100) {
      if (Array.isArray(imgs)) {
        this.fileList = imgs.map(item => {
          return {
            name: item.fileExplainName,
            url: item.filePath,
            uid: item.fileId,
            percent: 100
          }
        })
      } else {
        if (imgs) {
          this.fileList = [{
            name: imgs.fileExplainName,
            url: imgs.filePath,
            uid: imgs.fileId,
            percent: 100
          }]
        }
      }
      this.cropperOption.autoCropWidth = width
      this.cropperOption.autoCropHeight = height
      this.cropperStyle = {
        width: width * 1 + 'px',
        height: height * 1 + 'px'
      }
    },
    handlePreview (file) {
      window.open(file.url)
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      this.fileList.splice(index, 1)
      this.$emit('change', this.limit > 1 ? this.fileList : this.fileList[0])
      console.log(index)
    },
    handleCrop ({ file }) {
      console.log(file)
      // 点击弹出剪裁框
      this.$nextTick(() => {
        if (this.canCropper) {
          console.log(file)
          this.cropperOption.filename = file.uid + (file.name.substring(file.name.lastIndexOf('.')))
          this.cropperOption.img = window.URL.createObjectURL(file)
          this.showCropper = this.canCropper
        }
      })
    },
    beforeAvatarUpload (file) {
      console.log(file)
      // 上传前校验
      // const isJPG =
      //   file.type === "image/jpeg" ||
      //   file.type === "image/jpg" ||
      //   file.type === "image/png";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2 MB!");
      // }
      // // 校验通过后显示裁剪框
      // this.canCropper = isJPG && isLt2M;
      if (this.imgPicSuffix.includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())) {
        this.canCropper = true
      } else {
        this.canCropper = false
      }
      return !this.canCropper
    },
    // 自定义上传方法
    async uploadImg (file, data) {
      const name = file.name || file.file.uid + (file.file.name.substring(file.file.name.lastIndexOf('.')))
      console.log(file)
      const fileFormData = new FormData()
      fileFormData.append('file', file.file || file)
      console.log(this.fileList)
      if (this.$attrs.data) {
        for (const key in this.$attrs.data) {
          if (!this.$attrs.data[key]) {
            this.$message.error('参数不正确')
            this.fileList.splice(this.fileList.length - 1, 1)
            return
          }
          fileFormData.append(key, this.$attrs.data[key])
        }
      }
      // fileFormData.append("type", 0);
      // 移除上传组件带来的bug
      // document.getElementsByTagName('body')[0].removeAttribute('style')
      this.cropperData.iconUrl = data
      this.showCropper = false
      this.fileList.push({
        name: name,
        url: data,
        percent: 0,
        uid: new Date().getTime(),
        status: 'uploading'
      })
      axios.post(this.baseUrl + this.apiUrl, fileFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.$store.getters.token}`
        },
        onUploadProgress: (progressEvent) => {
          // 处理原生进度事件
          console.log(progressEvent)
          const percent = Number(progressEvent.loaded / progressEvent.total * 100).toFixed(0)
          this.$set(this.fileList[this.fileList.length - 1], 'percent', Number(percent))
        }
      }).then(res => {
        console.log(res)
        if (res.data.code === '20001') {
          this.$set(this.fileList[this.fileList.length - 1], 'url', res.data.data)
          // this.$set(this.fileList[this.fileList.length - 1], 'name', res.data.data.fileName)
          this.$set(this.fileList[this.fileList.length - 1], 'status', 'done')

          this.$emit('change', this.limit > 1 ? this.fileList : this.fileList[0])
        } else {
          this.$message.error(res.data.msg)
          this.fileList.splice(this.fileList.length - 1, 1)
        }
      })
      // this.cos.uploadFile({
      //   Bucket: this.Bucket, /* 填写自己的 bucket，必须字段 */
      //   Region: this.Region,     /* 存储桶所在地域，必须字段 */
      //   Key: name,              /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
      //   Body: file.file||file, // 上传文件对象
      //   SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
      //   onProgress: (progressData) => {
      //     console.log(JSON.stringify(progressData));
      //     let percent = Number(progressData.percent*100).toFixed(0)
      //     this.$set(this.fileList[this.fileList.length-1], 'percent', Number(percent))
      //   }
      // }, (err, ossData) => {
      //     if (err) {
      //       console.log('上传失败', err);
      //       this.$message.error(this.$t('上传失败'))
      //       this.fileList.splice(this.fileList.length-1, 1)
      //     } else {
      //       this.$message.success(this.$t('上传成功'))
      //       this.$emit('change', this.limit > 1?this.fileList.map(item => item.name):this.fileList[0].name)
      //     }
      //   }
      // )
    }
  }
}
</script>
<style lang="less" scoped>
.myupload{
  .file-list{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .zhezhao{
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.5);
      font-size: 14px;
      opacity: 0;
      a{
        color: white;
      }
    }
    &:hover{
      .zhezhao{
        opacity: 1;
      }
    }
  }
  ::v-deep{
    .el-upload-list{
    }
    .el-upload-list__item{
      &.is-success {

      }
    }
  }
  &.no-file{
    ::v-deep{
      .el-upload--picture-card{
        display: none;
      }
    }
  }
  .myupload-div{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: inherit;
    .el-icon-upload{
      margin: 0;
      line-height: initial;
    }
    .upload-text{
      line-height: initial;
    }
  }
}
.file-list{
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  -webkit-transition: border-color 0.3s ease;
  transition: border-color 0.3s ease;
  overflow: hidden;
  position: relative;
  padding: 8px;
  .info{
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }
  &:hover{
    .info{
      opacity: 1;
    }
  }

}
</style>
